import RemoteCall from "../../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/nursecarecore/hospital");

const getHospitalConfigAsync = (param) => {
    return remoteCall.invoke("getHospitalConfig", param);
};

const listValidHospitalsAsync = (param) => {
    return remoteCall._invoke("listValidHospitals", param);
};

export default {
    getHospitalConfigAsync,
    listValidHospitalsAsync,
};
